const TRACKING_PREFERENCE = 'TRACKING_PREFERENCE'
const TRACKING_SCRIPTS_LOADED = 'TRACKING_SCRIPTS_LOADED'
const MARKETING_TAGS_ADDED = 'MARKETING_TAGS_ADDED'

export { TRACKING_PREFERENCE, TRACKING_SCRIPTS_LOADED, MARKETING_TAGS_ADDED }
